import uuid from "react-uuid";

const initState = {
  processes: [],
};

const ProcessReducer = (state = initState, action) => {
  if (action.type === "initiate") {
    return {
      ...state,
      processes: action.payload,
    };
  }
  if (action.type === "add_station") {
    return {
      ...state,
      processes: state.processes.concat({
        id: uuid(),
        stationName: "",
        oneJaw1To7: "",
        twoJaw1To7: "",
        oneJaw7To14: "",
        twoJaw7To14: "",
        twoJaw14To21: "",
        twoJaw21To28: "",
        oneJawFull: "",
        twoJawFull: "",
      }),
    };
  }
  if (action.type === "delete_station") {
    return {
      ...state,
      processes: state.processes.filter((item) => item.id !== action.payload),
    };
  }
  if (action.type === "update_station") {
    return {
      ...state,
      processes: state.processes.map((process) => {
        if (process.id === action.payload.stationId) {
          process.stationName = action.payload.stationName;
          process.oneJaw1To7 = action.payload.oneJaw1To7;
          process.twoJaw1To7 = action.payload.twoJaw1To7;
          process.oneJaw7To14 = action.payload.oneJaw7To14;
          process.twoJaw7To14 = action.payload.twoJaw7To14;
          process.twoJaw14To21 = action.payload.twoJaw14To21;
          process.twoJaw21To28 = action.payload.twoJaw21To28;
          process.oneJawFull = action.payload.oneJawFull;
          process.twoJawFull = action.payload.twoJawFull;
          return process;
        } else {
          return process;
        }
      }),
    };
  }
  return state;
};

export default ProcessReducer;
